module.exports = __webpack_public_path__ + "img/CM-PW-24-Kia-Modern.0a9e2bee.jpg";